module.exports = __webpack_public_path__ + "static/media/bg_plan_suggestion_under_30.7bbb9bd7.webp";